import { render, staticRenderFns } from "./login-register.vue?vue&type=template&id=3b13155a&scoped=true&"
import script from "./login-register.vue?vue&type=script&lang=js&"
export * from "./login-register.vue?vue&type=script&lang=js&"
import style0 from "./login-register.vue?vue&type=style&index=0&id=3b13155a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b13155a",
  null
  
)

export default component.exports